import { Autocomplete } from "@material-ui/lab";
import { ptBR } from "date-fns/locale";
import { useEffect, useState } from "react";

import MaterialUI from "../../../../../material-UI";
import axiosLead from "../../../../../services/lead";
import * as Styles from "../../../styles";
import * as SVGIcons from "../../../../../assets/iconsSVG";

interface Props {
  dataProgramadaValue: any;
  functionDataChange: any;
  functionEmpreendimentoChange?: any;
  horaProgramadaValue: any;
  functionHoraChange: any;
  descricaoValue: any;
  functionDescricaoChange: any;
  emprendimentoValue?: any;
  checkValue: any;
  functionCheckChange: any;
  produtoInput?: boolean;
  produtoInputSetado?: boolean;
  empreendimentoSelectedValue: Function;
  count: number;
}

export function NovaTarefaForm(props: Props) {
  const [enterprises, setEnterprises] = useState<
    Array<{ id: string; nome: string; bandeira: string }>
  >([]);

  const [empreendimentoSelected, setEmpreendimentoSelected] = useState<any>("");

  useEffect(() => {
    props.empreendimentoSelectedValue(empreendimentoSelected);
  }, [empreendimentoSelected, props.empreendimentoSelectedValue]);

  const requestEnterprise = async () => {
    try {
      const response = await axiosLead.GetEnterprises();
      const enterprisesData: Array<{
        id: string;
        nome: string;
        bandeira: string;
      }> = response.data.data;
      enterprisesData.push({
        id: "",
        nome: "",
        bandeira: "",
      });
      setEnterprises(response.data.data);
    } catch (error) {
      console.log("Erro ao listar empreendimentos.");
    }
  };

  useEffect(() => {
    requestEnterprise();
  }, []);
  return (
    <>
      <Styles.DividerNovaTarefa>
        <p>Nova Tarefa</p>
      </Styles.DividerNovaTarefa>
      <Styles.LocalizationProvider
        locale={ptBR}
        dateAdapter={MaterialUI.AdapterDateFns}
      >
        <Styles.LineRow>
          <Styles.TransferComponent
            style={{ width: 349, paddingRight: 8, minHeight: 0 }}
          >
            <Styles.DesktopDatePicker
              inputFormat="dd/MM/yyyy"
              value={props.dataProgramadaValue}
              onChange={props.functionDataChange}
              components={{
                OpenPickerIcon: SVGIcons.CalendarSelectIcon,
              }}
              InputAdornmentProps={{ position: "start" }}
              renderInput={(params: any) => (
                <>
                  <Styles.LabelText>Data *</Styles.LabelText>
                  <Styles.TextField
                    size="small"
                    InputLabelProps={{ shrink: false }}
                    variant="outlined"
                    {...params}
                    label="Data *"
                    fullWidth
                    required
                  />
                </>
              )}
            />
          </Styles.TransferComponent>
          <Styles.TransferComponent
            style={{ width: 349, paddingLeft: 8, minHeight: 0 }}
          >
            <Styles.TimePicker
              label="Time"
              value={props.horaProgramadaValue}
              onChange={props.functionHoraChange}
              components={{
                OpenPickerIcon: SVGIcons.ClockIcon,
              }}
              InputAdornmentProps={{ position: "start" }}
              renderInput={(params: any) => (
                <>
                  <Styles.LabelText>Hora* </Styles.LabelText>
                  <Styles.TextField
                    size="small"
                    InputLabelProps={{ shrink: false }}
                    variant="outlined"
                    {...params}
                    label="Hora* "
                    fullWidth
                    required
                  />
                </>
              )}
            />
          </Styles.TransferComponent>
        </Styles.LineRow>
      </Styles.LocalizationProvider>
      {props?.produtoInputSetado ? (
        <Styles.FieldDiv>
          <Styles.LabelText>Produto</Styles.LabelText>
          <Styles.TextField
            size="small"
            defaultValue={props.emprendimentoValue}
            variant="outlined"
            fullWidth
            value={props.emprendimentoValue}
            disabled
            className="input-disabled"
          />
        </Styles.FieldDiv>
      ) : (
        <></>
      )}
      {props?.produtoInput ? (
        <>
          <Styles.TransferComponent style={{ marginTop: 8, minHeight: 0 }}>
            <Styles.LabelText>Produto *</Styles.LabelText>
            <Autocomplete
              id="combo-box-demo"
              options={enterprises.map(
                (item: { nome: string; id: string; bandeira: string }) => ({
                  label: item.nome,
                  value: item.id,
                  bandeira: item.bandeira,
                })
              )}
              defaultValue={empreendimentoSelected}
              value={empreendimentoSelected}
              getOptionSelected={(option: any) => option.label || ""}
              getOptionLabel={(option: any) => option.label || ""}
              // @ts-ignore
              onChange={(event: any, newValue: string | null) => {
                setEmpreendimentoSelected(newValue);
                props.functionEmpreendimentoChange();
              }}
              renderInput={(params: any) => (
                <>
                  <Styles.TextField variant="outlined" {...params} />
                </>
              )}
            />
          </Styles.TransferComponent>
        </>
      ) : (
        <></>
      )}
      <Styles.TransferComponent
        style={{ paddingBottom: 0, marginTop: 16, minHeight: 0 }}
      >
        <Styles.MultLineField>
          <Styles.LabelText>Descrição da nova tarefa</Styles.LabelText>
          <Styles.TextField
            onChange={props.functionDescricaoChange}
            label="Multiline"
            variant="outlined"
            fullWidth
            multiline
            minRows={3}
            value={props.descricaoValue}
            inputProps={{ maxLength: 4000 }}
          />
          <Styles.CountText>{props.count}/4000</Styles.CountText>
        </Styles.MultLineField>
      </Styles.TransferComponent>
      <Styles.FormControlLabel
        style={{ marginTop: 0 }}
        control={
          <Styles.Checkbox
            defaultChecked
            checked={props.checkValue}
            onChange={props.functionCheckChange}
          />
        }
        label="Criar compromisso na agenda"
      />
    </>
  );
}
